import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import {
  DataStateChangeEvent,
  GridDataResult,
  PageChangeEvent,
  GridComponent
} from '@progress/kendo-angular-grid';
import {
  CompositeFilterDescriptor,
  process,
  State,
} from '@progress/kendo-data-query';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SortDescriptor } from '@progress/kendo-data-query';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Validations } from '../../../shared/constants/validations';
import { SharedService } from '../../../shared/shared.service';
import {
  createpayloadConfig,
  getAllpayloadConfig,
  updatepayloadConfig,
} from '../../../store/payload_Config/payloadConfig.actions';
import { Store } from '@ngrx/store';
import { PayloadConfigService } from '../../../core/services/payloadConfig.services';
import {
  ConfirmationModal,
  ResponseConfiguration,
  table_pageSize,
} from '../../../shared/modals/common';
import { SweetAlertIcon } from '../../../shared/constants/enum';
import { LoaderService } from '../../../core/services/loader.service';
import { KeyMapping } from '../../../shared/modals/common';
import { Helper } from '../../../core/helpers/helper';
import { ExcelExportComponent } from '@progress/kendo-angular-excel-export';
@Component({
  selector: 'app-iot-create-response-configuration',
  templateUrl: './iot-create-response-configuration.component.html',
  styleUrls: ['./iot-create-response-configuration.component.scss'],
})
export class IotCreateResponseConfigurationComponent implements OnInit {
  private readonly emptyProjectGuid = '00000000-0000-0000-0000-000000000000';
  public sort: SortDescriptor[] = [];
  public pageSize = 10;
  public skip = 0;
  public totalKeysMappingCount = 0;
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] };
  public keysMappedData: GridDataResult = { data: [], total: 0 };
  public payloadGridData: GridDataResult = { data: [], total: 0 };
  public keysmappingList: any[] = [];
  
  //@ViewChild('excelexport', { static: true });
  @ViewChild('pdfGrid') public hiddenGrid: GridComponent | undefined;
  @ViewChild('pdfGrid1') public hiddenGrid1: GridComponent | undefined;
  excelExport!: ExcelExportComponent;
  @ViewChild('addConfigurationTemplate')
  addConfigurationTemplate!: TemplateRef<any>;
  isAllOpen: boolean = true;
  public createkeysMappingForm!: UntypedFormGroup;
  responseConfigurationForm!: UntypedFormGroup;
  public submitted = false;
  Configurationsubmitted = false;
  public modalRef?: BsModalRef;
  projectBillingDates = [];
  keysMappingData: any;
  keysmappingValidations = Validations.keymappingForm;
  configData: any;
  payloadData: any = [];
  evPayloadOptions: any[] = [];
  isEvSelected: boolean = false;
  private selectedSupplierName = '';
  private evPayloadOptionsLoaded = false;
  private evPayloadOptionsLoading = false;
  private evPayloadOptionsRequestId = 0;
  public editRowIndex: number | null = null;
  formType: string = '';
  itemBeingEdited: any;
  breadCrumbItems: Array<{}> | undefined;

  public buttonCount = 5;
  public info = true;
  public type: 'numeric' | 'input' = 'numeric';
  public pageSizes = table_pageSize.pageSizes;
  public previousNext = true;
  public payloadState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  public keymapState: State = {
    skip: 0,
    take: 10,
    filter: {
      logic: 'and',
      filters: [],
    },
  };

  totalMasterCount: number = 0;
  currentPage: number = 1;
  orderByQuery: string = '';
  filterqueryString: string = '';
  supplierOrderByQuery: string = '';
  responseConfigData: any;
  responseConfigurationFormValidations = Validations.ResponseConfigurationForm;
  constructor(
    private store: Store,
    private modalService: BsModalService,
    private formBuilder: UntypedFormBuilder,
    private sharedService: SharedService,
    private responseService: PayloadConfigService,
    private loaderService: LoaderService
  ) {
    this.responseConfigurationForm = this.formBuilder.group({
      responseName: ['', [Validators.required, Helper.noWhitespaceValidator()]],   // Added default value for the form control
      projectId: [null, Validators.required],     // Added default value for the form control
      supplierId: [null, Validators.required],      // Added default value for the form control
      payload: ['', [Validators.required,Helper.noWhitespaceValidator()]],       // Added default value for the form control
      gatewayAddress: ['', [Validators.required, Helper.noWhitespaceValidator()]],// Added default value for the form control
      deviceAddress: ['', [Validators.required, Helper.noWhitespaceValidator()]], // Added default value for the form control
      methodUrlMappingId: ['', Validators.required], // Added default value
      methodUrl: [{ value: '', disabled: true }, Validators.required], // Moved Validators.required outside of the control config
    });
    
    this.createkeysMappingForm = this.formBuilder.group({
      id: [],
      keyName: [null],
      keyDisplayName: ['', [Validators.required, Helper.noWhitespaceValidator()]],
      jsonkeyName: ['', [Validators.required, Helper.noWhitespaceValidator()]],
    });
    this.breadCrumbItems = [
      { label: 'Configurations', url: 'configuration', active: true },
      { label: 'Create Configurations' },
    ];
  }
  isSelectAll: boolean = true;
  selectedRowdata: any = [];
  deselectedRowdata: any = [];
  SaveConfig(type: string) {
    this.Configurationsubmitted = true;
    this.updateKeyMappingValidators();
    if (this.createkeysMappingForm.invalid) {
      this.createkeysMappingForm.markAllAsTouched();
      return;
    }
    else {
      const formValue = this.createkeysMappingForm.getRawValue();

      if (type == 'Create') {
        this.keysmappingList.push(
          this.normalizeKeyMappingRow(formValue)
        );
        this.totalKeysMappingCount = this.keysmappingList.length;
        this.hideAddConfigurationModal();
        this.loadKeysMappings();
      } else if (type === 'Update') {
        const updatedMapping = this.normalizeKeyMappingRow({
          ...this.itemBeingEdited,
          ...formValue,
          EVKeyName: formValue.keyName,
        });
        const index = this.keysmappingList.findIndex((item) =>
          this.isSameKeyMappingRow(item, this.itemBeingEdited)
        );

        if (index !== -1) {
          this.keysmappingList = this.keysmappingList.map((item, itemIndex) =>
            itemIndex === index ? updatedMapping : item
          );
          this.hideAddConfigurationModal();
          this.loadKeysMappings();
        }
      }
      this.Configurationsubmitted = false;
      this.createkeysMappingForm.reset();
    }
  }

  onSortChangePayloadGrid(sort: SortDescriptor[]): void {
    this.payloadState.sort = sort;
    console.log(this.payloadState.sort);
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.payloadState.sort
    );

    this.orderByQuery = orderByQuery;
    this.loadPayloadGridData();
  }

  public onMasterFilter(value: any): void {
    const inputValue = value;
  }
  onExport(type: string) {
    if (type === 'Excel') {
      if (this.keysMappedData.data.length > 0) {
        setTimeout(() => {
          this.hiddenGrid?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    } 
  }
  PayloadonExport(type: string) {
    if (type === 'Excel') {
      if (this.payloadGridData.data.length > 0) {
        setTimeout(() => {
          this.hiddenGrid1?.saveAsExcel();
        }, 1000);
      } else {
        this.sharedService.showMessageDialog(
          'No data to display',
          '',
          SweetAlertIcon.ERROR
        );
      }
    }
  } 
  onSelect(event: any) {
    // console.log(event.selectedRows);
    var selectedval = event.selectedRows;
    var deselectedVal = event.deselectedRows;
    if (selectedval.length > 0) {
      selectedval.forEach((element: any) => {
        this.selectedRowdata.push(element.dataItem);
        //    console.log(' selected Values : ', this.selectedRowdata);
      });
    }
    if (deselectedVal.length > 0) {
      deselectedVal.forEach((element: any) => {
        this.deselectedRowdata.push(element.dataItem);
        //    console.log('deselectedRowdata Values : ', this.deselectedRowdata);
      });

      if (this.deselectedRowdata.length > 0) {
        const idsToRemove = new Set(
          this.deselectedRowdata.map((item: { id: any }) => item.id)
        );

        const filteredArray = this.selectedRowdata.filter(
          (item: { id: unknown }) => !idsToRemove.has(item.id)
        );
        //    console.log('', filteredArray);
        this.selectedRowdata = filteredArray;
      }
    }
    //   console.log(this.selectedRowdata);
  }
  protected payloadPageChange({ skip, take }: PageChangeEvent): void {
    console.log('>>>', skip, take);
    this.skip = skip;
    this.pageSize = take;
    this.currentPage = Math.floor(skip / take) + 1;
    this.loadPayloadGridData();
  }

  generateRandomId(): string {
    return '_' + Math.random().toString(36).substr(2, 9);
  }

  get keysControls() {
    return this.createkeysMappingForm.controls;
  }
  ngOnInit(): void {
    this.getAllConfigData();
    // this.totalKeysMappingCount = this.keysmappingList.length;
    // this.loadKeysMappings();
  }

  onSelectSupplier(supplier: any, type: string) {
    console.log(supplier);
    const supplierId = this.getEntityId(supplier);
    this.setEvSupplierState(supplier, supplierId);
    if (!supplierId) {
      return;
    }
    this.sharedService
      .getAllConfigDatawithGateWayProviderId(supplierId)
      .subscribe((data) => {
        if (
          data.statusCode == 200 &&
          data.message == 'Config data retrieved successfully.'
        ) {
          this.configData = data.data;
          this.responseConfigurationForm.patchValue({
            methodUrlMappingId: '',
            methodUrl: '',
          });

          if (history.state.responseConfigData && type == 'Edit') {
            this.responseConfigData = JSON.parse(
              history.state.responseConfigData
            );
            this.responseConfigurationForm.patchValue({
              methodUrlMappingId:
                this.responseConfigData.responseMethodUrlMapping.id,
              methodUrl:
                this.responseConfigData.responseMethodUrlMapping.methodUrl,
            });
          } else {
            this.payloadData = [];
            this.skip = 0;
            this.pageSize = 10;
            this.sort = [];
            this.filter = { logic: 'and', filters: [] };
            this.loadPayloadGridData();
          }
        }
      });
  }

  private setEvSupplierState(supplier: any, supplierId?: any): void {
    const supplierName =
      supplier?.name ||
      this.configData?.gatewayProviders?.find(
        (item: any) =>
          item.id === supplier?.id ||
          item.id === supplier ||
          item.id === supplierId
      )?.name ||
      this.responseConfigData?.supplier?.name ||
      this.selectedSupplierName;

    this.selectedSupplierName = supplierName || '';

    this.isEvSelected = (supplierName || '').trim().toLowerCase() === 'ev';
    this.updateResponseConfigValidators();
    this.updateKeyMappingValidators();

    if (this.isEvSelected) {
      this.ensureEvPayloadOptionsLoaded();
    } else {
      this.evPayloadOptions = [];
      this.evPayloadOptionsLoaded = false;
    }
  }

  private updateResponseConfigValidators(): void {
    const payloadControl = this.responseConfigurationForm.get('payload');
    const gatewayAddressControl =
      this.responseConfigurationForm.get('gatewayAddress');

    if (this.isEvSelected) {
      payloadControl?.clearValidators();
      gatewayAddressControl?.clearValidators();
    } else {
      payloadControl?.setValidators([
        Validators.required,
        Helper.noWhitespaceValidator(),
      ]);
      gatewayAddressControl?.setValidators([
        Validators.required,
        Helper.noWhitespaceValidator(),
      ]);
    }

    payloadControl?.updateValueAndValidity();
    gatewayAddressControl?.updateValueAndValidity();
  }

  private updateKeyMappingValidators(): void {
    const keyNameControl = this.createkeysMappingForm.get('keyName');

    if (this.isEvSelected) {
      keyNameControl?.setValidators([Validators.required]);
    } else {
      keyNameControl?.clearValidators();
      keyNameControl?.setValue(null);
    }

    keyNameControl?.updateValueAndValidity();
  }

  private loadEvPayloadOptions(): void {
    this.evPayloadOptionsLoading = true;
    const requestId = ++this.evPayloadOptionsRequestId;

    this.responseService.getEvPayloadOptions(this.emptyProjectGuid).subscribe({
      next: (data) => {
        if (requestId !== this.evPayloadOptionsRequestId) {
          return;
        }

        if (Number(data?.statusCode) === 200) {
          const responseData = data?.data ?? [];
          const options = Array.isArray(responseData)
            ? responseData
            : responseData?.items ?? [];
          this.evPayloadOptions = options
            .map((item: any) => this.mapEvPayloadOption(item))
            .filter((item: any) => !!item.evKeyValue);
        } else {
          this.evPayloadOptions = [];
        }
        this.evPayloadOptionsLoaded = true;
        this.evPayloadOptionsLoading = false;
      },
      error: () => {
        if (requestId !== this.evPayloadOptionsRequestId) {
          return;
        }

        this.evPayloadOptions = [];
        this.evPayloadOptionsLoaded = true;
        this.evPayloadOptionsLoading = false;
      },
    });
  }

  private ensureEvPayloadOptionsLoaded(): void {
    if (
      this.isEvSelected &&
      !this.evPayloadOptionsLoaded &&
      !this.evPayloadOptionsLoading
    ) {
      this.loadEvPayloadOptions();
    }
  }

  private ensureEvPayloadOptionExists(keyName: string | null): void {
    if (!keyName) {
      return;
    }

    const exists = this.evPayloadOptions.some(
      (item: any) => item.evKeyValue === keyName
    );

    if (!exists) {
      this.evPayloadOptions = [
        ...this.evPayloadOptions,
        {
          evKeyValue: keyName,
          keyName: keyName,
          evKeyDisplayName: keyName,
        },
      ];
    }
  }

  private mapEvPayloadOption(item: any): any {
    if (typeof item === 'string') {
      return {
        evKeyValue: item,
        keyName: item,
        evKeyDisplayName: item,
      };
    }

    const evKeyValue =
      item?.value ||
      item?.EVKeyName ||
      item?.evKeyName ||
      item?.eVKeyName ||
      item?.keyName ||
      this.getEvPayloadLabel(item);
    const evKeyDisplayName =
      item?.keyName || item?.displayName || this.getEvPayloadDisplayName(item);

    return {
      ...item,
      evKeyValue,
      evKeyDisplayName,
    };
  }

  getEvPayloadLabel(option: any): string {
    return (
      option?.EVKeyName ||
      option?.evKeyName ||
      option?.eVKeyName ||
      option?.keyName ||
      option?.key ||
      option?.name ||
      option?.jsonkeyName ||
      option?.parameterName ||
      option?.payloadName ||
      ''
    );
  }

  getEvPayloadDisplayName(option: any): string {
    return (
      option?.KeyDisplayName ||
      option?.keyDisplayName ||
      option?.displayName ||
      option?.keyName ||
      option?.name ||
      ''
    );
  }

  private getEvKeyName(item: any): string | null {
    return (
      item?.EVKeyName ||
      item?.evKeyName ||
      item?.eVKeyName ||
      item?.keyName ||
      item?.evKeyValue ||
      item?.rippleKeyName ||
      item?.value ||
      null
    );
  }

  onSelectEvKeyName(option: any): void {
    if (!option) {
      this.createkeysMappingForm.patchValue({ keyDisplayName: '' });
      return;
    }

    if (typeof option === 'string') {
      option =
        this.evPayloadOptions.find((item: any) => item.evKeyValue === option) ||
        { evKeyValue: option, keyName: option };
    }

    const rippleKeyName = option.evKeyValue || option.value || '';
    const keyDisplayName = option.keyName || option.evKeyDisplayName || '';

    this.createkeysMappingForm.patchValue({
      keyName: rippleKeyName,
      keyDisplayName,
    });
  }

  onSelectMethod(method: any): void {
    console.log(method);

    const payload = {
      Utility: method.utility,
      gatewayProviderId: this.responseConfigurationForm.value.supplierId,
    };

    this.responseService.getPayloadConfigUrl(payload).subscribe((data) => {
      if (data.statusCode === 200) {
        this.payloadData = data.data;
        this.skip = 0;
        this.pageSize = 10;
        this.sort = [];
        this.filter = { logic: 'and', filters: [] };
        this.loadPayloadGridData();
      }
    });

    this.responseConfigurationForm.patchValue({
      methodUrl: method.methodUrl,
    });

    console.log(this.responseConfigurationForm.value);
  }

  public editHandler(rowIndex: number): void {
    this.editRowIndex = rowIndex;
  }

  public saveHandler(rowIndex: number): void {
     console.log(this.payloadData[rowIndex]);
    this.editRowIndex = null;
    const rowData = this.payloadData[rowIndex];
    if (!rowData.keyDisplayName || rowData.keyDisplayName.trim().length === 0) {
      this.sharedService.showMessageDialog(
        'Invalid Input',
        'Payload Display Name cannot be empty or contain only spaces.',
        SweetAlertIcon.ERROR
      );
      return; // ⛔ stop save
    }
    console.log(this.editRowIndex);
    this.loadPayloadGridData(); // Refresh the grid data
  }

  public cancelHandler(): void {
    this.editRowIndex = null;
  }

  loadPayloadGridData() {
    const state: State = {
      skip: this.skip,
      take: this.pageSize,
      sort: this.sort,
      filter: this.filter,
    };

    const processedData = process(this.payloadData, state);

    this.payloadGridData = {
      data: processedData.data,
      total: this.payloadData.length,
    };
  }
  getAllConfigData(): void {
    this.sharedService.getAllConfigData().subscribe((data) => {
      if (
        data.statusCode == 200 &&
        data.message == 'Config data retrieved successfully.'
      ) {
        this.configData = data.data;
        if (history.state.responseConfigData) {
          this.responseConfigData = JSON.parse(
            history.state.responseConfigData
          );
          this.breadCrumbItems = [
            { label: 'Configurations', url: 'configuration', active: true },
            {
              label: this.responseConfigData
                ? 'Edit Configurations'
                : 'Create Configurations',
            },
          ];
          this.responseConfigurationForm.patchValue({
            responseName: this.responseConfigData?.responseName,
            projectId:this.responseConfigData?.projectId!=null? this.responseConfigData?.projectId:null,
            supplierId: this.responseConfigData?.supplier.id!==null? this.responseConfigData?.supplier.id:null,
            payload: this.responseConfigData?.payload,
            gatewayAddress: this.responseConfigData?.gatewayAddress,
            deviceAddress: this.responseConfigData?.deviceAddress,
            methodUrlMappingId:
              this.responseConfigData?.responseMethodUrlMapping?.id,
            methodUrl:
              this.responseConfigData?.responseMethodUrlMapping?.methodUrl,
          });
          let supplier = { id: this.responseConfigurationForm.value.supplierId };
          this.keysmappingList = (
            this.responseConfigData?.keyMappings || []
          ).map((item: any) => this.normalizeKeyMappingRow(item));
          this.loadKeysMappings();
          this.onSelectSupplier(supplier, 'Edit');
          if (this.responseConfigData?.payloadMethodUrlMappings) {
            this.payloadData =
              this.responseConfigData.payloadMethodUrlMappings.map(
                (item: any) => ({
                  id: item.payloadConfiguration?.id,
                  keyDisplayName: item.displayName,
                  utility: item.payloadConfiguration?.utility,
                  parameterName: item?.payloadConfiguration?.parameterName,
                  positionFrom: item?.payloadConfiguration?.positionFrom,
                  positionTo: item?.payloadConfiguration?.positionTo,
                })
              );
          }
          this.loadPayloadGridData();
        }
      }
    });
  }
  onFilter(data: any) {}

  private loadKeysMappings(): void {
    this.totalKeysMappingCount = this.keysmappingList.length;
    const state: State = {
      skip: this.skip,
      take: this.pageSize,
      sort: this.sort,
      filter: this.filter,
    };

    const processedData = process(this.keysmappingList, state);

    this.keysMappedData = {
      data: processedData.data,
      total: this.totalKeysMappingCount,
    };
  }

  public onFilterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.loadKeysMappings();
  }

  public onPayloadFilterChange(filter: CompositeFilterDescriptor): void {
    this.filter = filter;
    this.loadKeysMappings();
  }

  public onSortChange(sort: SortDescriptor[]): void {
    this.sort = sort;
    this.loadKeysMappings();
  }

  public onPageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.pageSize = event.take;
    this.loadKeysMappings();
  }

  protected supplierPageChange({ skip, take }: PageChangeEvent): void {
    console.log('>>>', skip, take);
    this.skip = skip;
    this.pageSize = take;
    this.currentPage = Math.floor(skip / take) + 1;
    console.log('currentpage', Math.floor(skip / take) + 1);
    this.loadKeysMappings();
  }
  onSupplierFilterChange(filter: CompositeFilterDescriptor): void {
    this.keymapState.filter = filter;
    console.log(this.keymapState);
    const queryString = this.sharedService.createQuery(this.keymapState);
    this.filterqueryString = this.sharedService.createQuery(this.keymapState);
    this.loadKeysMappings();
    console.log(queryString);
  }

  onkeysSortChange(sort: SortDescriptor[]): void {
    this.keymapState.sort = sort;
    const orderByQuery = this.sharedService.createOrderByQuery(
      this.keymapState.sort
    );

    this.supplierOrderByQuery = orderByQuery;
    this.loadKeysMappings();
  }

  protected supplierdataStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.loadKeysMappings();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.sort = state.sort || [];
    this.pageSize = state.take;
    this.filter = state.filter || { logic: 'and', filters: [] };
    this.skip = state.skip;
    this.loadKeysMappings();
  }

  public showAddConfigurationModalAndCallMethod(): void {
    this.formType = 'Add';
    this.createkeysMappingForm.reset();
    this.updateKeyMappingValidators();
    this.Configurationsubmitted = false;
    this.ensureEvPayloadOptionsLoaded();
    this.modalRef = this.modalService.show(this.addConfigurationTemplate);
  }

  onEdit(dataItem: any): void {
    this.itemBeingEdited = dataItem;
    this.updateKeyMappingValidators();
    this.ensureEvPayloadOptionsLoaded();
    const keyName = this.getEvKeyName(dataItem);
    this.ensureEvPayloadOptionExists(keyName);
    this.createkeysMappingForm.patchValue({
      ...dataItem,
      keyName,
    });
    this.formType = 'Edit';
    this.modalRef = this.modalService.show(this.addConfigurationTemplate);
  }

  private normalizeKeyMappingRow(item: any): any {
    const keyName = this.getEvKeyName(item);

    return {
      ...item,
      id: item?.id || this.generateRandomId(),
      keyName,
      EVKeyName: keyName,
      keyDisplayName: item?.keyDisplayName || item?.KeyDisplayName || '',
      jsonkeyName:
        item?.jsonkeyName || item?.JsonkeyName || item?.jsonKeyName || '',
    };
  }

  private isSameKeyMappingRow(item: any, selectedItem: any): boolean {
    if (!item || !selectedItem) {
      return false;
    }

    if (item.id && selectedItem.id) {
      return item.id === selectedItem.id;
    }

    return (
      item.keyDisplayName === selectedItem.keyDisplayName &&
      item.jsonkeyName === selectedItem.jsonkeyName &&
      this.getEvKeyName(item) === this.getEvKeyName(selectedItem)
    );
  }
  onDelete(dataItem: any): void {
    let modalInfo: ConfirmationModal = {
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: SweetAlertIcon.ERROR,
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
    };
    this.sharedService.showConfirmationDialog(modalInfo).then((result) => {
      console.log(result);

      if (result.isConfirmed) {
        // Perform delete operation here
        this.keysmappingList = this.keysmappingList.filter(
          (item) => item.id !== dataItem.id
        );
        this.sharedService.showMessageDialog(
          'Deleted!',
          'Your row has been deleted.',
          SweetAlertIcon.SUCCESS
        );

        this.loadKeysMappings();
      } else if (
        /* Read more about handling dismissals below */
        result.dismiss === Swal.DismissReason.cancel
      ) {
        this.sharedService.showMessageDialog(
          'Cancelled',
          '',
          SweetAlertIcon.INFO
        );
      }
      // else if (result.dismiss === Swal.DismissReason.cancel) {
      //   // Handle cancellation
      // }
    });
  }

  public hideAddConfigurationModal(): void {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  private getEntityId(item: any): any {
    return (
      item?.id ||
      item?.Id ||
      item?.projectId ||
      item?.ProjectId ||
      item?.gatewayProviderId ||
      item?.GatewayProviderId ||
      item?._id ||
      item
    );
  }

  private getOptionalEvValue(value: any): string {
    return this.isEvSelected && (!value || value.trim?.() === '')
      ? 'N/A'
      : value;
  }

  public saveProject(): void {
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: 'All the changes have been saved.',
      showConfirmButton: true,
    });
  }
  saveConfiguration(type: any) {
    this.submitted = true;
    this.updateResponseConfigValidators();
    if (this.responseConfigurationForm.valid) {
      const keyMappings: any[] = this.keysmappingList.map((item) => ({
        KeyDisplayName: item.keyDisplayName,
        JsonkeyName: item.jsonkeyName,
        ...(this.isEvSelected
          ? { EVKeyName: this.getEvKeyName(item) }
          : {}),
      }));

      const payloadMethodUrlMappings = this.payloadData.map((payload: any) => ({
        displayName: payload.keyDisplayName,
        payloadConfigurationId: payload.id,
        methodUrlMappingId:
          this.responseConfigurationForm.value.methodUrlMappingId,
      }));

      const payload: ResponseConfiguration = {
        responseName: this.responseConfigurationForm.value.responseName,
        projectId: this.responseConfigurationForm.value.projectId,
        supplierId: this.responseConfigurationForm.value.supplierId,
        payload: this.getOptionalEvValue(
          this.responseConfigurationForm.value.payload
        ),
        gatewayAddress: this.getOptionalEvValue(
          this.responseConfigurationForm.value.gatewayAddress
        ),
        deviceAddress: this.responseConfigurationForm.value.deviceAddress,
        keyMappings: keyMappings,
        responseMethodUrlMapping: {
          methodUrlMappingId:
            this.responseConfigurationForm.value.methodUrlMappingId,
        },
        payloadMethodUrlMappings: payloadMethodUrlMappings, // Add your payloadMethodUrlMappings data here
      };
      if (type == 'Create') {
        console.log(payload);
        this.store.dispatch(
          createpayloadConfig({ payloadConfigData: payload })
        );
      } else {
        this.store.dispatch(
          updatepayloadConfig({
            payloadConfigData: payload,
            id: this.responseConfigData.id,
          })
        );
      }
    } else {
      this.responseConfigurationForm.markAllAsTouched();
    }
  }
}
